import { useState } from 'react';
import { Button } from 'antd';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs';

import { isAdmin } from '.';
import { ADMIN_BADGE } from '../components/icons';

/**
 * Admin-only raw JSON dump, behind a plain outline toggle (the platform
 * action grammar has no yellow buttons; this is a debug affordance, not a
 * call to action).
 */
export function AdminJSON( { obj = {}, label = null, } = {} ) {

	const [ objOpen, setObjOpen ] = useState( false );

	// only display for admin
	if ( ! isAdmin() ) {
		return <></>;
	}

	return (
		<div className='admin-json'>
			<Button
				size='small'
				icon={<ADMIN_BADGE />}
				onClick={() => setObjOpen( ! objOpen )}
			>
				{label ? label + ' ' : ''}
				JSON
				{objOpen ? <BsChevronUp /> : <BsChevronDown />}
			</Button>
			{objOpen ? (
				<pre className='admin-json__dump'>{JSON.stringify( obj, null, '\t' )}</pre>
			) : null}
		</div>
	);

}
